import Design from './design'

export default Design
